import { Heart, LogOut, Package, Store, UserRound } from "lucide-react"
import Link from "next/link"
import { type ReactNode } from "react"
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "~/components/ui/dropdown-menu"
import { Avatar, AvatarFallback } from "~/components/ui/avatar"
import { shortName } from "~/lib/utils"
import { useClientAuth } from "~/hooks/use-auth"
import { signOut } from "next-auth/react"
import { useTrigger } from "~/hooks/use-trigger"

interface UserNavProps {
    children: ReactNode,
    mobileNav?: boolean
}

const UserNav = ({ children, mobileNav }: UserNavProps) => {
    const { isUser, isAdmin } = useClientAuth();
    const { toggleState } = useTrigger();
    const handleClose = () => {
        if (mobileNav) {
            toggleState('isOpenMenu')
        }
    }
    return (
        <DropdownMenu>
         <DropdownMenuTrigger asChild>
            {children}
         </DropdownMenuTrigger>
         <DropdownMenuContent className="min-w-56 rounded-lg" align="end" forceMount>
            <DropdownMenuLabel className="font-normal p-0">
                <div className="flex items-center gap-2 text-left text-sm px-1 py-1.5">
                    <Avatar className="rounded-full size-[40px]">
                        <AvatarFallback className="rounded-lg">{shortName(isUser?.name ?? "RK")}</AvatarFallback>
                    </Avatar>
                    <div className="grid flex-1 text-left text-sm leading-tight">
                        <span className="truncate font-semibold">{isUser?.name ?? "Rahul Kumar"}</span>
                        <span className="truncate text-xs">{isUser?.email ?? "rksahu2601@gmail.com"}</span>
                    </div>
                </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            {!!isAdmin && (
                <>
                    <Link href="/admin">
                        <DropdownMenuItem onClick={() => handleClose()}>
                            <Store />
                            Admin
                        </DropdownMenuItem>
                    </Link>
                    <DropdownMenuSeparator />
                </>
            )}
            <DropdownMenuGroup>
                <Link href="/profile">
                    <DropdownMenuItem onClick={() => handleClose()}>
                        <UserRound />
                        Profile
                    </DropdownMenuItem>
                </Link>
                <Link href="/order">
                    <DropdownMenuItem onClick={() => handleClose()}>
                        <Package />
                        Order
                    </DropdownMenuItem>
                </Link>
                <Link href="/wishlists">
                    <DropdownMenuItem onClick={() => handleClose()}>
                        <Heart />
                        Wishlist
                    </DropdownMenuItem>
                </Link>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem className="text-red-500 focus:text-red-500 focus:bg-red-500/10" onClick={async () => { await signOut(); handleClose()}}>
                <LogOut />
                Logout
            </DropdownMenuItem>
         </DropdownMenuContent>
      </DropdownMenu>
    )
}

export { UserNav }
